module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "br3 bw1 b--silver bg-white flex flex-column main-container mb3 relative justify-center"
  }, [_c('div', {
    staticClass: "flex flex-row"
  }, [_c('div', {
    staticClass: "flex flex-column mr3 icon items-center justify-center"
  }, [_c('device-icon'), _vm._v(" "), _c('div', {
    staticClass: "self-center cera-round-pro mt2 nowrap"
  }, [_vm._v("\n        Phone #" + _vm._s(_vm.phoneIndex + 1) + "\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column justify-between pv1 w-100"
  }, [_c('device-input', {
    attrs: {
      "disabled": _vm.partnerDevices && _vm.partnerDevices[_vm.phoneIndex] || null,
      "index": _vm.phoneIndex,
      "optionsSet": _vm.allMakes,
      "setValue": _vm.setMake,
      "value": _vm.selectedPhone.make,
      "label": "Make",
      "placeholder": "Select a make"
    }
  }), _vm._v(" "), _c('device-input', {
    attrs: {
      "disabled": _vm.partnerDevices && _vm.partnerDevices[_vm.phoneIndex] || null,
      "index": _vm.phoneIndex,
      "optionsSet": _vm.filterModelsBySelectedMake(_vm.selectedPhone.make),
      "setValue": _vm.setModel,
      "value": _vm.selectedPhone.model,
      "label": "Model",
      "placeholder": "Select a model"
    }
  })], 1)]), _vm._v(" "), (_vm.isRemovable) ? _c('div', {
    staticClass: "custom-position pointer",
    on: {
      "click": function($event) {
        return _vm.removeItem(_vm.phoneIndex, $event)
      }
    }
  }, [_c('trash-icon')], 1) : _vm._e(), _vm._v(" "), (!_vm.isPhoneOnly) ? _c('plan-type-toggle', {
    attrs: {
      "phoneIndex": _vm.phoneIndex,
      "setValue": _vm.setIsAdult,
      "toggleName": 'adultToggle' + _vm.phoneIndex,
      "toggleValue": _vm.selectedPhone.adult,
      "customClass": "mt2 w-70 self-end justify-end h-20",
      "customTextClass": "f7 padding",
      "firstOption": "For Adult",
      "secondOption": "For Student"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0db54e62","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/selectBox/EditDevice.vue
// module id = 738
// module chunks = 0